module.exports = __webpack_public_path__ + "media/images/icon/newwindow-primary-49272ab8fecd419b602ff9873e8805ee.png";